import React, { Component } from 'react';
import { Button, ControlLabel, FormGroup, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';

import { KeyLicenseTypes, OnlineLicenseTypes } from '../common/keyLicenseTypes';
import { isDeviceKeyValid } from '../common/keyValidation';
import { showModalMessage } from '../store/modalsSlice';
import * as permanentLicensesActions from '../store/permanentLicensesSlice';
import { permanentLicensesSelectors } from '../store/permanentLicensesSlice';
import * as temporaryLicensesActions from '../store/temporaryLicensesSlice';
import { temporaryLicensesSelectors } from '../store/temporaryLicensesSlice';

import DeviceKeyInputNormalized from '../components/deviceKeyInputNormalized';
import { unwrapResult } from '@reduxjs/toolkit';

class OnlineLicenseActivationDialog extends Component {
  initState = {
    deviceKey: ''
  };

  constructor(props) {
    super(props);
    this.handleClose = this.props.onClose;

    this.state = this.initState;

    this.onShow = this.onShow.bind(this);
    this.onClose = this.onClose.bind(this);

    this.onDeviceKeyChanged = this.onDeviceKeyChanged.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onShow() {
    if (!OnlineLicenseTypes.includes(this.props.licenseType)) {
      this.onClose();
      this.props.showModalMessage('Error', 'Unsupported license type');
    }
    this.setState(this.initState);
  }

  onClose() {
    this.handleClose();
    this.setState(this.initState);
  }

  onDeviceKeyChanged(normalizedValue) {
    this.setState({ deviceKey: normalizedValue });
  }

  isCorrectDeviceKey() {
    return isDeviceKeyValid(this.state.deviceKey.trim());
  }

  isSubmitButtonDisabled() {
    return !this.isCorrectDeviceKey();
  }

  onSubmit() {
    this.onClose();
    this.props.activateLicense[this.props.licenseType]({
      licenseId: this.props.licenseId, deviceKey: this.state.deviceKey
    })
      .then(unwrapResult)
      .then(() => {
        this.props.onSuccess();
      })
      .catch(() => {
        this.props.showModalMessage("Error", this.props.onSubmitError[this.props.licenseType].toString());
      });
  }

  render() {
    return (
      <Modal bsSize="small" show={this.props.show} onShow={this.onShow} onHide={this.onClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>License activating</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup controlId="fcDeviceKey">
            <ControlLabel>Device key</ControlLabel>
            <DeviceKeyInputNormalized onChange={this.onDeviceKeyChanged} />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.onSubmit} disabled={this.isSubmitButtonDisabled()}>
            Activate
          </Button>
          <Button onClick={this.onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  onSubmitError: {
    [KeyLicenseTypes.OnlineTemporary]: temporaryLicensesSelectors.creatingUpdatingError(state),
    [KeyLicenseTypes.OnlinePermanent]: permanentLicensesSelectors.creatingUpdatingChangingError(state),
  }
});

const mapDispatchToProps = (dispatch) => ({
  activateLicense: {
    [KeyLicenseTypes.OnlinePermanent]: (args) =>
      dispatch(permanentLicensesActions.activate(args)),

    [KeyLicenseTypes.OnlineTemporary]: (args) =>
      dispatch(temporaryLicensesActions.activate(args)),
  },
  showModalMessage: (title, text) => dispatch(showModalMessage({ title, text })),
});

export default connect(mapStateToProps, mapDispatchToProps)(OnlineLicenseActivationDialog);



// WEBPACK FOOTER //
// ./src/containers/onlineLicenseActivationDialog.js